/*
 * MyEbike add-to-cart helper
 *
 * Intercepts any <form data-mb-pc-add> submission, POSTs to
 * /cart/add.js, updates cart counts + the drawer, and slides the
 * drawer open instead of reloading the page. Falls back to native
 * form submit if fetch fails.
 */

(function () {
  function updateCount(count) {
    const bubble = document.querySelector('.mb-header__count');
    const cartLink = document.querySelector('[data-mb-cart-toggle]');
    if (cartLink) {
      // Toggle .is-filled so the gradient accent only appears when items > 0
      cartLink.classList.toggle('is-filled', count > 0);
      cartLink.setAttribute('data-mb-cart-count', String(count));
      if (!bubble && count > 0) {
        const span = document.createElement('span');
        span.className = 'mb-header__count';
        span.textContent = String(count);
        cartLink.appendChild(span);
      } else if (bubble) {
        if (count > 0) bubble.textContent = String(count);
        else bubble.remove();
      }
    }
    document.querySelectorAll('[data-mb-cart-count-heading]').forEach(el => {
      el.textContent = count > 0 ? ` (${count})` : '';
    });
  }

  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`, {
        headers: { 'Accept': 'text/html' },
      });
      if (!res.ok) return;
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const incoming = doc.querySelector('cart-drawer');
      const existing = document.querySelector('cart-drawer');
      if (incoming && existing) {
        existing.innerHTML = incoming.innerHTML;
        existing.classList.toggle('is-empty', incoming.classList.contains('is-empty'));
        // Notify wired-once listeners (fulfilment chooser, etc.) that DOM was swapped
        document.dispatchEvent(new CustomEvent('mb:cart:updated'));
      }
    } catch (e) { /* drawer will re-render next page load */ }
  }

  // Monkey-patch fetch to refresh the header cart bubble after ANY cart mutation.
  // Dawn's cart.js / cart-drawer-items handle quantity changes and removes via fetch
  // to /cart/change.js, /cart/update.js, /cart/clear.js — the header bubble was only
  // wired to our own add-to-cart flow, so qty/remove edits left it stale.
  (function patchFetch() {
    if (typeof window.fetch !== 'function' || window.__mbCartFetchPatched) return;
    window.__mbCartFetchPatched = true;
    const cartMutationRe = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    const origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartMutation = cartMutationRe.test(url);
      const promise = origFetch(input, init);
      if (isCartMutation) {
        promise.then(() => {
          // Use a fresh GET — many of the change endpoints already return cart JSON,
          // but to be format-safe we fetch /cart.js explicitly.
          origFetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(r => r.ok ? r.json() : null)
            .then(cart => {
              if (cart && typeof cart.item_count === 'number') {
                updateCount(cart.item_count);
                document.dispatchEvent(new CustomEvent('mb:cart:updated', { detail: { cart } }));
              }
            })
            .catch(() => {});
        }).catch(() => {});
      }
      return promise;
    };
  })();

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[data-mb-pc-add]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.dataset.prevText = btn.innerHTML; btn.innerHTML = 'Adding…'; }

    const fd = new FormData(form);
    try {
      const addRes = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!addRes.ok) throw new Error('add failed');
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCount(cart.item_count);
      await refreshDrawer();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(form);
      else window.location.href = '/cart';
    } catch (err) {
      form.submit();
    } finally {
      if (btn) {
        btn.disabled = false;
        if (btn.dataset.prevText) btn.innerHTML = btn.dataset.prevText;
      }
    }
  });
})();
